import type {CanvasChatMessage,CanvasPlaceholder} from './canvas-types';
export interface FailedSlotRun {id:number;status?:string;skeletonKey?:string|null;input?:{sourceClientId?:string;canvasPreview?:{slots?:Array<{id:string;x:number;y:number;width:number;height:number}>}}}
type DeliveredImage={id:string;src:string;workflowRunId?:number|null};
const slotRunId=(conceptKey?:string)=>{const match=/^(\d+):/.exec(conceptKey??'');return match?Number(match[1]):undefined;};

/** Chat indexes span the whole assistant stream, including multiple runs. */
function chatSlotOffset(run:FailedSlotRun,message:CanvasChatMessage,images:readonly DeliveredImage[]):number|undefined {
 const planned=run.input?.canvasPreview?.slots??[];
 const offsets=new Set<number>();
 for(const slot of message.imageSlots??[]){
  if(!slot.resolved)continue;
  const image=images.find(image=>image.src===slot.resolved&&image.workflowRunId===run.id);
  const localIndex=image?planned.findIndex(position=>position.id===image.id):-1;
  if(localIndex>=0)offsets.add(slot.index-localIndex);
 }
 if(offsets.size===1)return Array.from(offsets)[0];
 if(offsets.size>1)return;
 const slots=message.imageSlots??[];
 // An all-failed, explicitly owned single run has no delivered anchor. Only
 // use its indexes if the complete local slot range is saved without overlap.
 if(message.playbookProgress?.workflowRunId===run.id&&slots.length===planned.length&&
  slots.every(slot=>!slot.resolved&&(slotRunId(slot.conceptKey)??run.id)===run.id)&&
  slots.map(slot=>slot.index).sort((a,b)=>a-b).every((index,position)=>index===position))return 0;
}
/** Failed slots are presentation state, never generated images or new jobs. */
export function failedSlotPlaceholders(runs:readonly FailedSlotRun[],messages:readonly CanvasChatMessage[],images:readonly DeliveredImage[],current:Record<string,CanvasPlaceholder>):Record<string,CanvasPlaceholder>{
 const next={...current};
 for(const run of runs){
  const planned=run.input?.canvasPreview?.slots;
  if(!planned?.length)continue;
  const ownImages=images.filter(image=>image.workflowRunId===run.id&&image.src);
  const owners=messages.filter(message=>{
   if(message.role!=='assistant')return false;
   const declaredRun=message.playbookProgress?.workflowRunId;
   return declaredRun===run.id||message.id===`run-card-${run.id}`||message.imageSlots?.some(slot=>slotRunId(slot.conceptKey)===run.id)||ownImages.some(image=>message.imageSlots?.some(slot=>slot.resolved===image.src));
  });
  for(const message of owners){
   const offset=chatSlotOffset(run,message,images);
   if(offset===undefined)continue;
   for(const slot of message.imageSlots??[]){
   if(!slot.failed||slot.resolved||!Number.isInteger(slot.index))continue;
   if(slotRunId(slot.conceptKey)!==undefined&&slotRunId(slot.conceptKey)!==run.id)continue;
   const localIndex=slot.index-offset;
   const position=planned[localIndex];
   if(!position||!position.id||![position.x,position.y,position.width,position.height].every(Number.isFinite)||position.width<=0||position.height<=0)continue;
   if(images.some(image=>image.id===position.id&&image.src))continue;
   if(Object.values(next).some(existing=>existing.taskId===`agent-img-${position.id}`||((existing.workflowRunId===run.id||(existing.workflowRunId==null&&existing.batchId===message.id))&&existing.slotIndex===localIndex)))continue;
   const taskId=`failed-run-${run.id}-${localIndex}`;
   next[taskId]={taskId,x:position.x,y:position.y,width:position.width,height:position.height,failed:true,errorMsg:slot.errorMsg,batchId:message.id,workflowRunId:run.id,slotIndex:localIndex};
   }
  }
 }
 return next;
}
